export default __webpack_public_path__ + "static/media/logo.ece6438d.jpg";